import React from 'react';

import { SVGComponentProps } from './svg.types';

const NoFillSVG = ({
  fill = 'currentColor',
  size = '24',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 12C22 17.5228 17.5228 22 12 22C9.85257 22 7.86324 21.3231 6.23371 20.1711L20.1711 6.23371C21.3231 7.86324 22 9.85257 22 12ZM4.72026 18.8561L18.8561 4.72026C17.0659 3.03364 14.6537 2 12 2C6.47715 2 2 6.47715 2 12C2 14.6537 3.03364 17.0659 4.72026 18.8561ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default NoFillSVG;
